const mainDomain = "https://users.bestembroidery.org/";
// const mainDomain = "http://localhost:5001/"

const frontendUrl = "https://users.bestembroidery.org";
// const frontendUrl = "http://localhost:3000";

const Constants = {
  imgDomain: "https://users.bestembroidery.org/",
  imgDomainPreview: "https://users.bestembroidery.org",
  frontendUrl,
  cardknoxUrl: "https://secure.cardknox.com/bestembroiderydev",
  createUpsShipment: mainDomain + "ups/shipments/create",
  // imgDomain: "http://localhost:5001",
  // imgDomainPreview: "http://localhost:5001",
  
  // Category Names
  categoryNames: {
    TALLIS_TEFILLIN: "Tallis/Tefillin Bags",
    PASSOVER: "Custom Passover Sets",
  },
  
  getUrls: {
    getProfile: mainDomain + "user/getAdminProfile",
    getUserList: mainDomain + "user",
    testimonials: mainDomain + "testimonial",
    getAllCategory: mainDomain + "category",
    getAllSubcategory: mainDomain + "collection",
    getAllStyles: mainDomain + "styles",
    getAllFabric: mainDomain + "fabric",
    getFabrics: mainDomain + "fabric/Allfabric",
    getAllFabricType: mainDomain + "fabricType",
    getDigitizedImages: mainDomain + "order/digitized-images", // optional endpoint
    getDigitizeStatusDropdown:
      mainDomain + "order/get-digitize-status-dropdown",
    getAllProducts: mainDomain + "products",
    getAllGeneralProducts: mainDomain + "products/general-products",
    getAllVariants: mainDomain + "variants",
    getAllOrders: mainDomain + "order",
    // UPS Integration Endpoints
    upsConfig: mainDomain + "ups/config",
    upsTrack: mainDomain + "ups/track",
    upsOrderTrack: mainDomain + "ups/order",
    generateOrderQr: mainDomain + "order/generateQR",
    dashboard: mainDomain + "dashboard",
    getAllStyleByCatId: mainDomain + "styles/get-all",
    getAllDesign: mainDomain + "design",
    getAllThread: mainDomain + "thread",
    getAllSize: mainDomain + "size",
    getProduct: mainDomain + "products",
    getProductList: mainDomain + "products/product-list",
    getAdminCustomizedImage: mainDomain + "customized_image/admin",
    getUserDefaultAddress:
      mainDomain + "useraddress/get-user-default-address-by-userid",
    getOrderStatusDropdown: mainDomain + "order/get-order-status-dropdown",
    getFactoryStatusDropdown: mainDomain + "order/get-factory-status-dropdown",
    getAllAddOns: mainDomain + "addOn",
    getAddOnById: mainDomain + "addOn",
    getOrder: mainDomain + "order",
  },
  postUrls: {
    addProducts: mainDomain + "products/create",
    login: mainDomain + "user/login",
    createTestimonial: mainDomain + "testimonial/create",
    Addcategory: mainDomain + "category/create",
    AddSubcategory: mainDomain + "collection/create",
    AddStyles: mainDomain + "styles/create",
    AddDesign: mainDomain + "design/create",
    addVariants: mainDomain + "variants/create",
    AddFabric: mainDomain + "fabric/create",
    AddFabricType: mainDomain + "fabricType/create",
    AddThread: mainDomain + "thread/create",
    AddSize: mainDomain + "size/create",
    uploadCustomizedImage: mainDomain + "customized_image/upload",
    refundOrder: mainDomain + "checkout/refund",
    payNowOrder: mainDomain + "checkout/admin-pay-now/",
    uploadDigitizedImage: mainDomain + "order/upload-digitized-image",
    createAddOn: mainDomain + "addOn/create",
    // UPS Integration Endpoints
    validateUpsAddress: mainDomain + "ups/address/validate",
    upsTimeInTransit: mainDomain + "ups/time-in-transit",
    createUpsShipment: mainDomain + "ups/shipments/create",
    recoverUpsLabel: mainDomain + "ups/shipments/labels",
  },
  putUrls: {
    updateTestimonial: mainDomain + "testimonial/update/",
    deleteTestimonial: mainDomain + "testimonial/delete/",
    updateCategory: mainDomain + "category/update",
    updateSubCategory: mainDomain + "collection/update",
    updateProducts: mainDomain + "products/update",
    updateVariants: mainDomain + "variants/update",
    productStatus: mainDomain + "products/status/",
    variantStatus: mainDomain + "variants/status/",
    categoryStatus: mainDomain + "category/status/",
    subCategoryStatus: mainDomain + "collection/status/",
    changeOrderStatus: mainDomain + "order/change-status",
    updateUserTax: mainDomain + "user/update-tax/",
    updateUserDiscount: mainDomain + "user/update-discount/",
    updateStyles: mainDomain + "styles/update",
    styleStatsChange: mainDomain + "styles/status/",
    updateFabric: mainDomain + "fabric/update",
    updateFabricType: mainDomain + "fabricType/update",
    fabricStatsChange: mainDomain + "fabric/status/",
    fabricTypeStatsChange: mainDomain + "fabricType/status/",
    designStatusChange: mainDomain + "design/status/",
    updateDesign: mainDomain + "design/update",
    updateThread: mainDomain + "thread/update",
    threadStatusChange: mainDomain + "thread/status/",
    updateSize: mainDomain + "size/update",
    sizeStatusChange: mainDomain + "size/status/",
    changeFactoryStatus: mainDomain + "order/change-factory-status",
    changeDigitizeStatus: mainDomain + "order/change-digitize-status",
    fabricStockChange: mainDomain + "fabric/stock",
     addOnStatusChange: mainDomain + "addOn/status",
  },
  patchUrls: {
    togglePinFabric: mainDomain + "fabric/toggle-pin",
    togglePinDesign: mainDomain + "design/toggle-pin",
    updateAddOn: mainDomain + "addOn/update",
   
  },
  deleteUrls: {
    deleteProducts: mainDomain + "products/delete",
    deleteVariants: mainDomain + "variants/delete",
    deleteCategory: mainDomain + "category/delete/",
    deleteSubCategory: mainDomain + "collection/delete/",
    deleteUser: mainDomain + "user/delete/",
    deleteStyles: mainDomain + "styles/delete/",
    deleteFabric: mainDomain + "fabric/delete/",
    deleteFabricType: mainDomain + "fabricType/delete/",
    deleteDesign: mainDomain + "design/delete/",
    deleteThread: mainDomain + "thread/delete/",
    deleteDesignImage: mainDomain + "design/delete_design_image/",
    deleteSize: mainDomain + "size/delete/",
    removeCustomizedImage: mainDomain + "customized_image/delete",
    deleteDigitizedImage: mainDomain + "order/digitized-image",
    deleteAddOn: mainDomain + "addOn/delete",
    // UPS Integration Endpoints
    cancelUpsShipment: mainDomain + "ups/shipments/cancel",
  },
};
export default Constants;
